import ROUTING_STATE_SHAPE from 'rlink-router/ROUTING_STATE_SHAPE';

export default function getLoadedMessages (routing, locale) {
  return ROUTING_STATE_SHAPE.getAt(routing, ['messages', locale]);
}



// WEBPACK FOOTER //
// ./lib/rlink-router/getLoadedMessages.js